module.exports = __webpack_public_path__ + "static/media/slide4.63248922.gif";